module.exports = __webpack_public_path__ + "img/dr-deanna-rogge-broadway-chiropractic-clinic.1484af00.jpg";